import { Component } from '@angular/core';
import { IzzySkillIssueTypeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Skill Issue Types') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyskillissuetype-form',
    templateUrl: './izzyskillissuetype.form.component.html'
})
export class IzzySkillIssueTypeFormComponent extends BaseFormComponent {
    public record!: IzzySkillIssueTypeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

